import { motion } from 'framer-motion';

interface TimelinePreviewProps {
  startTime: number;
  endTime: number;
  duration: number;
}

export function TimelinePreview({
  startTime,
  endTime,
  duration,
}: TimelinePreviewProps) {
  const start = (startTime / duration) * 100;
  const width = ((endTime - startTime) / duration) * 100;

  return (
    <motion.div
      className="tw-absolute tw-h-8 tw-rounded tw-bg-blue-500/20 tw-border tw-border-blue-500/30"
      style={{
        top: '16px',
        left: `${start}%`,
        width: `${width}%`,
        zIndex: 10,
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    />
  );
}